import Layout from '@/layout'

const BiAnalysis = {
  path: '/BiAnalysis',
  component: Layout,
  redirect: 'noredirect',
  name: 'BiAnalysis',
  meta: {
    title: '',
    icon: 'daohang-ziliaoguanli'
  },
  children: [
    {
      path: 'BusinessIntelligenceDashboard',
      component: () => import('@/views/cargo/v0/BiAnalysis/businessIntelligenceDashboard'),
      name: 'BusinessIntelligenceDashboard',
      meta: { title: '数据驾驶舱' },
      roles: ['cockpit']
    }
  ]
}

export default BiAnalysis
